/**
 * Parses `children_ages` from the App Router `searchParams` object (single string or repeated key → string[])
 * or from an ordered list of raw age strings (e.g. URLSearchParams#getAll).
 * Mirrors `parseInt(age, 10) || 0` behavior used elsewhere for hotel search.
 */
export function parseChildrenAgesQueryValues(
  raw: string | string[] | undefined | null
): number[] {
  if (raw == null || raw === '') return []
  const parts = Array.isArray(raw) ? raw : [raw]
  return parts.map((age) => parseInt(String(age).trim(), 10) || 0)
}
